module.exports = __webpack_public_path__ + "3-es2015.880496070e17b1f1fc9e.worker.js"